import { create } from "zustand";

type NewDeviceModalState = {
    isOpen: boolean;
    hiveId?: string | number;
    hiveNumber?: string | number;
    open: (hiveId: string | number, hiveNumber: string | number) => void;
    close: () => void;
};

export const useNewDeviceModalStore = create<NewDeviceModalState>((set) => ({
    isOpen: false,
    openId: undefined,
    open: (hiveId, hiveNumber) => set({ isOpen: true, hiveId: hiveId, hiveNumber: hiveNumber }),
    close: () => set({ isOpen: false, hiveId: undefined }),
}));
